<template>
 <div>
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >
  <tr max-height="48px" height="48px"  >
      
<ContenidoBase 
  :titulo="'Reporte de Cheques Por Beneficiario'"
  :descripcion="'Imprime Reporte Cheques Por Beneficiario'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="save"
   @MethodEliminar="remove"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"
   
/>
    </tr>
  
  
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesChequesBeneficiario'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>

      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 
<!-- Formulario-Cheques Por Beneficiario -->
 <v-container >
  <v-card color="grey lighten-3">

<v-toolbar
        flat
        color="#BDBDBD"
        dense
        style="border: 1px solid #000000;"
      >
        
  
 <v-avatar tile  size="45"  >
      <img
        src="@/assets/iconos_micromarket/custom-reports.png"
        alt="Reporte"
      >
    </v-avatar>

    
<span class="font-weight-light" style="font-size: 20px;" > Reporte de Cheques Por Beneficiario </span >

  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
   <!-- style="color:white;" -->
    <!-- <i class=""> </i> -->

        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
      </v-toolbar>
           
<hr>

  <v-container style="border: 1px solid #000000;">
  <v-form ref="form" @submit.prevent=""  v-model="valid" lazy-validation>
              <v-row>
<!-- columna 1 -->
<v-col cols="12" md="6" sm="6">



  <!-- -----------------------------  desde  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="Desde:"
         :rules="[$rules.required]"
        v-model="ChequesBeneficiario.desde"
        @blur="BlurDesde"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

                </v-text-field>

<!-------------------------------------------------------- beneficio -->
                    <v-combobox
                          autocomplete="off"
                          dense
                          outlined
                          label="* Beneficiario:"
                          :items="Rproveedor"
                          item-text="nombre"
                          :rules="[$rules.required]"
                          v-model="proveedor"
                          @focus="cargarProveedor"
                          @keyup="CbFilProveedor"
                          @blur="SelctCbProveedor"
                        >
                          <template v-slot:prepend>
                            <i
                              style="font-size: 20px"
                              class="fa fa-user-circle"
                            ></i>
                          </template>
                        </v-combobox>

<!-- -----------------------------  Hasta  -->

<VueAutonumeric label="(Monto) Desde:" 
  dense 
  outlined
 autocomplete="off"
  v-model.number="ChequesBeneficiario.desdeMonto"
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric>

</v-col>
<!-- fn columna 1 -->


<!-- columna 2 -->
<v-col cols="12" md="6" sm="6">

<!-- -----------------------------  Hasta  -->
<v-text-field
        dense
        outlined
        type="date" 
         :rules="[$rules.required]" 
        label="Hasta:"
        v-model="ChequesBeneficiario.hasta"
        @blur="BlurHasta"

        
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

                </v-text-field>


 <!-------------------------------------------------------- Cuenta -->

<v-combobox
    v-model="ChequesBeneficiario.cuentaBanco"
    label="Cuenta de banco:"
    required
    outlined
    dense
    :rules="[$rules.required]"
    autocomplete="off"
    :items="RCuentaBanco"
    item-text="cuenta"
    @focus="cargarCuentaBanco"
    @blur="SelctCbCuentaBanco">  
      <template v-slot:prepend>
              <i
                style="font-size: 20px;"
                class="fa fa-sticky-note-o"
              ></i>
            </template>
</v-combobox>

<!-- -----------------------------  Hasta  -->

<VueAutonumeric label="(Monto) Hasta:" 
  dense 
  outlined
 autocomplete="off"
  v-model.number="ChequesBeneficiario.hastaMonto"
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric>
      
</v-col>


<v-col cols="12" md="6" sm="6">
  <v-radio-group style="margin-top:-20px;"  v-model="ChequesBeneficiario.RadioOpc" column>     
                  <v-radio label="Normal" color="teal lighten-2" :value="1"></v-radio>
                  <v-radio label="Resumido por cuenta de banco por mes" color="teal lighten-2" :value="2"></v-radio>                                       
                  <v-radio label="Resumido por benficiario por mes" color="teal lighten-2" :value="3"></v-radio>                                       
                  <v-radio label="Resumido por beneficiario" color="teal lighten-2" :value="4"></v-radio>                                       
</v-radio-group>
</v-col>

<v-col cols="12" md="6" sm="6" v-if="ChequesBeneficiario.RadioOpc==1">
<center >

                        <span style="font-size: 12px"><b>ORDENAR REPORTE POR:</b></span>
                        <v-radio-group v-model="ChequesBeneficiario.ordenOpc" class="pt-0 mt-0 d-flex justify-center " dense
                                       hide-details
                                       row >
                          <!-- <v-radio label="RUTINARIOS" color="green" :value="1"></v-radio>
                          <v-radio label="NO RUTINARIOS" color="green" :value="2"></v-radio>-->
                          <v-radio :value="1" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">FECHA</strong>
                            </template>
                          </v-radio>
                          <v-radio id="no-enviada" :value="2" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">DOCUMENTO Y SECUENCIA</strong>
                            </template>
                          </v-radio>

                        </v-radio-group>
</center>
</v-col>

<!-- fn columna 2 -->
         
              </v-row>

            </v-form>
       </v-container>

<hr>




<ModalReporteFiltros ref="ModRepFilt"
@DataReporteBasico="DDataReporteBasico"
:Datos="ChequesBeneficiario"
/>



  </v-card>
 </v-container>
<!-- fn Formulario-Cheques Por Beneficiario -->
        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  
    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros from "../../components/ModalReporteFiltros";
import VueAutonumeric from "../../components/AutoNumericNuevo";
import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha
} from "@/js/Funciones.js";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros,
    VueAutonumeric
  },
  created() { 
    var json = {  
      titulo: "Reporte de Cheques Por Beneficiario",
      descripcion: "Imprime Reporte Cheques Por Beneficiario",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi:false,
      accion: [ 
        "ReportesChequesBeneficiarioNew",
        "ReportesChequesBeneficiarioSave",
        "ReportesChequesBeneficiarioRemove",
        "ReportesChequesBeneficiarioAnular",
        "ReportesChequesBeneficiarioPrintList"
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("ReportesChequesBeneficiarioNew", this.new);
    // EventBus.$on("ReportesChequesBeneficiarioSave", this.save);
    // EventBus.$on("ReportesChequesBeneficiarioRemove", this.remove);
    // EventBus.$on("ReportesChequesBeneficiarioAnular", this.remove);
    // EventBus.$on("ReportesChequesBeneficiarioPrintList", this.imprimirList);
    EventBus.$on("emitReportesChequesBeneficiario", this.datostabla);
    EventBus.$on("onResize", this.onResize);

    this.$refs.ModRepFilt.CrearObjecto = this.validarObjecto;
  },

  data:()=>  ({

      Rpropietario:[],
      Rproveedor:[],
      RCaja:[],
      RCuentaBanco:[],
      ListaTiposClientes: [],
      windowSize:{width:"auto", height:"auto"},
      proveedor:null,
      ChequesBeneficiario: {
        nombre:'CHEQUES POR BENEFICIARIO',
        UrlImprimir: '/reportesban/ImprimirChequesBeneficiario', 
        UrlExel: '/reportesban/ExcelChequesBeneficiario', 
        UrlCorreo: '/reportesban/CorreoChequesBeneficiario', 
        desdeMonto: 0,
        desde: fechaNueva(),
        hastaMonto:0,
        hasta: fechaNueva(),
        proveedor:null,
        cuentaBanco:null,
        RadioOpc:1,
        ordenOpc:1
        //fechaCreacion: new,
      //  fechaModificacion: "", 
      },

     EstadoBtn:{ 
        BarraTablaDinamicaAprir:false,
        nuevo:false,
        guardar:false,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        },


      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
   
      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,
onResize(e){

console.log("imprii ")

console.log(e)
this.windowSize=e


},

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },
  
    datostabla(e) {

      this.ChequesBeneficiario = e;
      this.acti_tb_data=false
    },
    save() { },
    remove() {},
    eliminar() {},
    anular() {},
    imprimirList(){},
    DDataReporteBasico(e){ },
    newwnuevo() {
      (this.ChequesBeneficiario = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },


     
BlurDesde(){

if(this.ChequesBeneficiario.desde.toString().length==0){
  this.ChequesBeneficiario.desde=this.fechaNueva()
}


 },


 BlurHasta(){

if(this.ChequesBeneficiario.hasta.toString().length==0){
  this.ChequesBeneficiario.hasta=this.fechaNueva()
}

 },



    // Realizar una solicitud GET al servidor y devolver los datos al componente Vue.
cargarCuentaBanco(){

this.$axios.get(this.$hostname+this.$hName+'/cuentabanco/findallactivo',
{headers:this.$store.getters.GetheadersAxios})
.then(res=>( this.RCuentaBanco=res.data))

},

// Comprobando si el valor de la selección es nulo o indefinido.
SelctCbCuentaBanco(){
  if(this.ChequesBeneficiario.cuentaBanco==null){
    this.ChequesBeneficiario.cuentaBanco=''
  }
  if(this.ChequesBeneficiario.cuentaBanco.codigo== undefined){
   // this.alerta("Seleccione un Cuenta Banco", "error");
    this.ChequesBeneficiario.cuentaBanco=''
  return
}

},


cargarProveedor() {
      this.$axios
        .get(this.$hostname + this.$hName + "/proveedores/findallbyDesc/25/0/*",
        { headers: this.$store.getters.GetheadersAxios })
        .then((res) => (this.Rproveedor = res.data));
    },

CbFilProveedor(e) {
      if (e.target.value.length >= 0) {
        this.$axios
          .get(
            this.$hostname +
              this.$hName +
              "/proveedores/findallbyDesc/25/0/" +
              (e.target.value === "" ? "*" : e.target.value),
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => (this.Rproveedor = res.data));
      }
    },


SelctCbProveedor(e){


if(e.target.value.toString().length>0){
this.ChequesBeneficiario.proveedor=e.target.value
}else{
  this.ChequesBeneficiario.proveedor=null
}


},

validarObjecto() {
  

  if(this.ChequesBeneficiario.RadioOpc==2 && this.ChequesBeneficiario.cuentaBanco==null ){
    this.$refs.ModRepFilt.detener = true;
    this.alerta("Seleccione una Cuenta de Banco", "error");
    return
  }else{
    this.$refs.ModRepFilt.detener = false;
  }


  if(this.ChequesBeneficiario.RadioOpc==3 && this.ChequesBeneficiario.proveedor==null ){
    this.$refs.ModRepFilt.detener = true;
    this.alerta("Seleccione o escriba un beneficiario", "error");
    return
  }else{
    this.$refs.ModRepFilt.detener = false;
  }


  /*<v-radio-group style="margin-top:-20px;"  v-model="ChequesBeneficiario.RadioOpc" column>     
                  <v-radio label="Normal" color="teal lighten-2" :value="1"></v-radio>
                  <v-radio label="Resumido por cuenta de banco por mes" color="teal lighten-2" :value="2"></v-radio>                                       
                  <v-radio label="Resumido por benficiario por mes" color="teal lighten-2" :value="3"></v-radio>                                       
                  <v-radio label="Resumido por beneficiario" color="teal lighten-2" :value="4"></v-radio>  */  



},


    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
      
    }
  }
};
</script>

<style></style>
